// extracted by mini-css-extract-plugin
module.exports = {"noLink":"TrustPilotWidget_noLink__V4Vz2"};